export default {
  className: '_User',
  fields: [
    {
      // 头像
      name: 'head'
    },
    {
      // 昵称
      name: 'nickName'
    },
    {
      name: 'isInland'
    },
    {
      // 性别
      name: 'sex'
    },
    {
      // 手机号
      name: 'username'
    }
  ],
  search: [
    'username',
    'nickName',
    'isInland'
  ],
  action: false,
  hooks: {
    beforeFetch ({ where }) {
      // 增加一个查询条件，仅查询激活的用户
      where.status = 'ordinary'
    }
  }
}
